<template>
    <div class="bwg_monitor">
        <el-scrollbar style="height: 100%;flex: 1;">
            <div class="elec_right" style="overflow-x: hidden"  v-cloak>
                <div class="elec_right_item" @click="goRouter(item)" v-for="item in nbqData.nbqList" :key="item">
                    <div class="elec_right_title">{{item.point_name}}</div>
                    <img class="elec_mac" src="../../../assets/image/custom/nbq_mac.png"/>
                    <!-- <div class="elec_title_div">
                        <img class="elec_title" src="../../../assets/image/custom/elec_title.png"/>
                        <span>{{item.point_name}}</span>
                    </div> -->
                    <div class="elec_item_inner">
                        <div class="inner_item">
                            <div>{{ $t('nbqList.anzhuangweizhi') }}：</div>
                            <div><i>{{item.position}}</i>&nbsp;</div>
                        </div>
                        <div class="inner_item">
                            <div>{{ $t('nbqList.xinghao') }}：</div>
                            <div><i>{{item.model}}</i>&nbsp;</div>
                        </div>
                        <div class="inner_item">
                            <div>{{ $t('nbqList.jiaoliugonglv') }}：</div>
                            <div><i>{{ item.rated_p }}</i>&nbsp;{{ item.rated_p_unit }}</div>
                        </div>
                        <div class="inner_item">
                            <div>{{ $t('nbqList.shishi') }}：</div>
                            <div><i>{{ item.p }}</i>&nbsp;{{ item.p_unit }}</div>
                        </div>
                        <div class="inner_item">
                            <div>{{ $t('nbqList.dayelec') }}：</div>
                            <div><i>{{ item.dtfdl }}</i>&nbsp;{{ item.dtfdl_unit }}</div>
                        </div>
                        <div class="inner_item">
                            <div>{{ $t('nbqList.runstate') }}：</div>
                            <div style="margin-left: -10rem">
                                {{ item.os | code_dce(that) }}
                                <!-- <img class="inner_pic" src="../../../assets/image/custom/run_pic.png" /> -->
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="elec_right_item" style="background: none">
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/gauge";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/graphic";
import utils from "@/utils/utils.js";
import { dayTransfer } from "@/utils/dateTransfer.js";
import { getDataAll } from "@/http/http-60.js";
import dayjs from "dayjs";
import * as api from "../../../http/Use_electricity_monitor";
import * as _api from "@/http/api.js";
import unitUtils from "@/utils/unit-exchange.js";
export default {
    data() {
        return {
            timer: null,
            point_id: '',
            point_60_id: '',
            nbqData: {},
            current_type: 'day',
            zgl: '',
            that: this,
        };
    },
    created() {
        this.point_id = this.$route.query.point_id;
        this.point_60_id = this.$route.query.point_60_id;
        this.getNbqList();
        this.setTimer();
    },
    filters: {
        code_dce(v, that){
            if(!v) return;
            let mun =parseInt(v);
            if(mun===0){return that.$t('osState.standbyInitializes')}
            else if(mun===1){return that.$t('osState.standbyInsulationImpedanceDetection')}
            else if(mun===2){return that.$t('osState.standbyLightDetection')}
            else if(mun===3){return that.$t('osState.standbyGridDetection')}
            else if(mun===256){return that.$t('osState.starting')}
            else if(mun===512){return that.$t('osState.gridConnectedRunning')}
            else if(mun===513){return that.$t('osState.gridConnectedLimitedPower')}
            else if(mun===514){return that.$t('osState.gridConnectedSelfReducingRatedPower')}
            else if(mun===768){return that.$t('osState.shutdownAbnormal')}
            else if(mun===769){return that.$t('osState.shutdownCommand')}
            else if(mun===770){return that.$t('osState.shutdownOVGR')}
            else if(mun===771){return that.$t('osState.shutdownCommunicationBreak')}
            else if(mun===772){return that.$t('osState.shutdownPowerLimited')}
            else if(mun===773){return that.$t('osState.shutdownMannualBoot')}
            else if(mun===774){return that.$t('osState.shutdownDCSwitchC')}
            else if(mun===775){return that.$t('osState.shutdownQuickShutdown')}
            else if(mun===776){return that.$t('osState.shutdownInputUnderpower')}
            else if(mun===1025){return that.$t('osState.powerGridDispatching')}
            else if(mun===1026){return that.$t('osState.powerGridDispatchingQU')}
            else if(mun===1027){return that.$t('osState.powerGridDispatchingPFU')}
            else if(mun===1028){return that.$t('osState.powerGridDispatchingDryContact')}
            else if(mun===1029){return that.$t('osState.powerGridDispatchingQP')}
            else if(mun===1280){return that.$t('osState.spotReady')}
            else if(mun===1281){return that.$t('osState.spotChecking')}
            else if(mun===1536){return that.$t('osState.duringInspection')}
            else if(mun===1792){return that.$t('osState.AFCIChecking')}
            else if(mun===2048){return that.$t('osState.IVScanning')}
            else if(mun===2304){return that.$t('osState.DCInputChecking')}
            else if(mun===2560){return that.$t('osState.runningChargingOffGrid')}
            else if(mun===40960){return that.$t('osState.standbyNoLight')}
            else {
                return v;
            }
        }
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getNbqList();
            }, 60000);
        },
        goRouter(item) {
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'nbq_power_manage', query:{ point_id: item.point_id, bwg_name: item.bwg_name, point_name: item.point_name, position: item.position, model: item.model }}));
            this.$router.push({ name:'nbq_power_manage', query:{ point_id: item.point_id, bwg_name: item.bwg_name, point_name: item.point_name, position: item.position, model: item.model } })
        },
        getNbqList() {
            _api.getNbqList({
                point_id: this.point_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.nbqData = res.bus_json;
                    if(this.nbqData && this.nbqData.nbqList && this.nbqData.nbqList.length) this.getData();
                } 
            });
        },
        getData() {
            let pointIds = [this.point_60_id];
            this.nbqData.nbqList.forEach(item => {
                pointIds.push(item.point_id);
            });
            getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                let point = valueJson[this.point_60_id];
                this.zgl = point && point.p;
                this.nbqData.nbqList.forEach(item => {
                    let point = valueJson[item.point_id];
                    // item['p'] = unitUtils.exchangeUnitKWH(point.p).num;
                    // item['p_unit'] = unitUtils.exchangeUnitKWH(data.p).unit;
                    // item['dtfdl'] = unitUtils.exchangeUnitKWH(data.dangtianfadianliang).num;
                    // item['dtfdl_unit'] = unitUtils.exchangeUnitKWH(data.dangtianfadianliang).unit;
                   

                    this.$set(item, 'p', unitUtils.exchangeUnitKW(point.p).num);
                    this.$set(item, 'p_unit', unitUtils.exchangeUnitKW(point.p).unit);
                   // this.$set(item, 'dtfdl', point && point.dangtianfadianliang);
                    this.$set(item, 'dtfdl', unitUtils.exchangeUnitKWH(point.dangtianfadianliang).num);
                    this.$set(item, 'dtfdl_unit', unitUtils.exchangeUnitKWH(point.dangtianfadianliang).unit);
                    this.$set(item, 'os', point && point.operatingstate);
                });
            });
        },
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.bwg_monitor {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: inline-flex;
    padding: 0 1rem;
    [v-cloak] {
	    display: none;
    }
    i {
        color: #56FCFF;
    }
    .elec_left_title {
        //  background: url(../../../assets/image/custom/elec_left_line.png) no-repeat;
        color: #56FCFF;
        //  background-size: 100% 100%;
        text-align: center;
        // height: 0.5rem;
        // width: 100%;
        width: 100%;
        height: 2.5rem;
        position: relative;
        span {
            position: absolute;
            top: 50%; 
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1rem;
        }
        img {
            width: 100%;
            height: auto;
            position: absolute;
            top: 50%; 
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .elec_common_item {
        display: inline-flex;
        flex-flow: column wrap;
        justify-content: space-evenly;
        width: 100%;
        height: calc(100% - 2rem);
        .elec_common_item_line {
            flex: 1;
            display: inline-flex;
            width: 100%;
            align-items: center;
            font-size: 0.8rem;
            div {
                //flex: 1;
                font-size: 0.8rem;
                line-height: 1.7rem;
                &:last-child {
                    text-align: right;
                }
                img {
                    width: 1rem;
                    height: 1rem;
                }
            }
        }
        .left_top {
            display: inline-flex; 
            flex-flow: column wrap; 
            justify-content: space-between; 
            align-items: flex-start;
            .left_top_chart {
                width: 100%;
                height: calc(100% - 1.7rem);
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .elec_custom_line {
            display: inline-flex;
            width: 100%;
            align-items: center;
            font-size: 0.8rem;
            .elec_item_line_pic {
                width: 1rem;
                img {
                    width: 0.8rem;
                }
            }
            .elec_item_line_cnt {
                width: 50%;
            }
        }
        .elec_custom {
            width: 50%; 
            flex: none !important
        }
    }
    .elec_left {
        width: 24%;
        margin-right: 3%;
        display: inline-flex;
        flex-flow: column wrap;
        justify-content: space-between;
        .elec_left_top {
            width: 100%;
            height: 28%;
            background: url(../../../assets/image/custom/elec_left_top.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem 1.2rem;
        }
        .elec_left_center {
            width: 100%;
            height: 20%;
            background: url(../../../assets/image/custom/elec_left_center.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem 1.2rem;
        }
        .elec_left_bottom {
            width: 100%;
            height: 48%;
            background: url(../../../assets/image/custom/elec_left_bottom.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem;
            .left_bottom_choose {
                width: 100%; display: inline-flex;justify-content: space-evenly;
                div {
                    width: 3rem;height: 1rem; border: 1px solid #56fcff; border-radius: 1rem; text-align: center; font-size: 0.8rem; line-height: 1rem;cursor: pointer;
                }
                .choose_s {
                    background: #56fcff;
                    color: #000;
                }
                .choose_us {
                    background: transparent;
                    color: #fff;
                }
            }
        }        
        .elec_chart_div {
            width: 100%;
            height: calc(100% - 4rem);
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
    .elec_right {
       // flex: 1;
        display: inline-flex;
        flex-flow: row wrap;
       // justify-content: space-between;
        .elec_right_item {
            width: 18%;
            height: 20rem;
            background: url(../../../assets/image/custom/bwg_rect.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 2rem 2rem 1rem 2rem;
            margin: 1% 1% 0 1%;
            position: relative;
            .elec_right_title {
                position: absolute; 
                top: 3%;
                left: 17%;
                font-size: 0.8rem;
            }
            .elec_mac {
                width: auto;
                height: 6.5rem;
                margin: 0 50%;
                transform: translate(-40%, 0);
            }
            .elec_title_div {
                width: 100%;
                position: relative;
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #56FCFF;
                    font-size: 0.6rem;
                }
                .elec_title {
                    width: 80%;
                    margin-left: 10%;
                    height: 1.2rem;
                }

            }
            .elec_item_inner {
                width: 100%;
                height: calc(100% - 6rem);
                display: inline-flex;
                justify-content: space-evenly;
                flex-flow: column wrap;
                .inner_item {
                    font-size: 0.7rem;
                    display: inline-flex;
                    div {
                        flex: 1;
                        height: 0.7rem;
                        &:last-child {
                            text-align: right;
                        }
                        .inner_pic {
                            width: 0.8rem;
                            height: 0.8rem;
                        }
                    }
                    .more_pic {
                        width: 100%;
                        height: auto;
                        
                    }
                    .more_pic_txt {
                        position: absolute; 
                        top: 50%;
                        left: 50%;
                        color: #fff; 
                        font-size: 0.7rem; 
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
}
</style>
